
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import ContactCTA from './components/ContactCTA';
import ContactForm from './components/ContactForm';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const handleFormSuccess = () => {
    // scroll to top after successful booking
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <Header />
      <HeroSection onFormSubmitSuccess={handleFormSuccess} />
      <ServiceSection />
      <ContactCTA />
      <ContactForm />
      <FinalCTA />
      <Footer />

      {/* Floating Call Button */}
      <a
        href="tel:3214468130"
        className="fixed bottom-6 right-6 bg-[#1E88E5] hover:bg-[#1976D2] text-white rounded-full shadow-2xl transition-all hover:scale-110 z-50 flex items-center gap-2 py-3 px-5 cursor-pointer"
        aria-label="Call Sunshine Air Pros Now"
      >
        <span className="text-sm font-semibold whitespace-nowrap">Call Us Now!</span>
        <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
          <i className="ri-phone-fill text-xl"></i>
        </div>
      </a>
    </div>
  );
}
